import Image from '@/components/Image';
import WapOnly from '@/components/Responsive/WapOnly';
import WebOnly from '@/components/Responsive/WebOnly';
import { env } from '@/utils/env';
import Link from 'next/link';

// 德语静态内容组件
export default function GermanContent() {
  const supportEmail = env.NEXT_PUBLIC_SUPPORT_EMAIL;

  return (
    <>
      <WebOnly>
        <div className="w-full py-[50px] px-[200px] text-[14px] font-ir">
          <p className="text-center my-[25px] leading-[24px]">
            Zeelool hat sich zum Ziel gesetzt, Ihnen eine perfekte Brille zum besten Preis
            anzubieten. Wenn Sie Probleme haben, zögern Sie bitte nicht, uns zu kontaktieren.
            <br />
            Unser Kundendienst wird Ihnen innerhalb von 45 Tagen nach Erhalt der Brille eine
            vernünftige Lösung für alle Arten von Problemen mit der Brille anbieten.
          </p>

          <div className="relative mb-[50px]">
            <Image
              src="static-page/return-refund/return-refund-01.jpeg"
              alt="Return & Refund"
              width={800}
              height={400}
              className="w-full"
            />
            <h1 className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center text-[36px] text-white font-bb">
              Rückgabe&Rückerstattung
            </h1>
          </div>

          <div className="space-y-[40px]">
            <p className="my-0 mx-auto leading-[24px] mb-[40px]">
              <strong className="font-bb"> · Adresse der Rücksendung: </strong>Wenn Sie den Artikel
              zurückschicken möchten, bitte senden Sie Ihre Bestellnummer und den Grund für
              Rücksendung an {supportEmail}. Unser Kundendienst wird Ihnen weiter die
              Rücksendeadresse mitteilen. Achtung: Die auf dem Paket angegebene Adresse ist nicht
              korrekte Rücksendeadresse. Rückerstattungen können nicht bearbeitet werden, wenn Sie
              an falsche Adresse schicken. Wir bitten um Verständnis.
            </p>

            <p className="my-0 mx-auto leading-[24px] mb-[40px]">
              <strong className="font-bb"> · Farbunterschied: </strong>Aufgrund unterschiedlicher
              Lichtverhältnisse in Sonnenlicht und Bildschirm können einige visuelle Unterschiede
              auftreten. Waren sind in Naturalien vorzuziehen. Bitte senden Sie Ihre Bestellnummer,
              ein Foto der erhaltenen Brille und eine Problembeschreibung an {supportEmail}. Wir
              werden uns innerhalb von 24 Stunden um Ihr Problem kümmern. Wenn Sie der Meinung sind,
              dass die Brille nicht Ihren Erwartungen entspricht, wenden Sie sich bitte innerhalb
              von 45 Tagen nach Erhalt der Brille an unseren Kundendienst.
            </p>

            <p className="my-0 mx-auto leading-[24px] mb-[40px]">
              <strong className="font-bb">· Über Rezept:</strong> Wenn die Brille nicht klar ist,
              überprüfen Sie bitte zuerst Ihr Rezept. Wenn das Rezept korrekt ist, können Sie es
              innerhalb der 45-tägigen Garantiezeit zur Überprüfung an uns zurücksenden, und wir
              werden Ihnen einen Ersatz oder eine Rückerstattung gewähren, wenn wir dafür
              verantwortlich sind; wenn Sie leider das falsche Rezept ausfüllen, können Sie einen
              speziellen Gutschein für Ihre neue Brille erhalten oder eine Rückerstattung (ohne
              Versand- und Gläserkosten) beantragen. Bitte senden Sie Ihre Bestellnummer, Ihr Rezept
              oder Brillenpass und eine Problembeschreibung an {supportEmail}. Wir werden uns
              innerhalb von 24 Stunden um Ihr Problem kümmern.
            </p>

            <p className="my-0 mx-auto leading-[24px] mb-[40px]">
              <strong className="font-bb">· Zusätzliches Rezept:</strong> Innerhalb von 12 Stunden
              nach der Bestellung, können Sie sich an den Kundendienst wenden, um das Brillenrezept
              ändern. Danach können Sie es nicht mehr ändern. Bitte senden Sie Ihre Bestellnummer,
              ein Bild Ihres Rezeptes und eine Problembeschreibung an {supportEmail}. Wir werden
              Ihnen innerhalb von 24 Stunden bei der Änderung helfen. Wenn Sie nach Erhalt des
              Rahmens eine Korrekturbrille wünschen, brauchen Sie nur für die Gläser zu bezahlen, um
              eine ganze Brille zu erhalten.
            </p>
            <p className="my-0 mx-auto leading-[24px] mb-[40px]">
              <strong className="font-bb">· Über die Größe:</strong> Aufgrund unterschiedlicher
              Messtechniken und Winkel tritt eine Abweichung der Rahmenparameter von ca. 1-2 mm auf,
              wobei die tatsächlichen Parameter in natura vorherrschen. Sie können die passende
              Brille finden, indem Sie sich die Größentabelle auf jeder Brillendetailseite ansehen.
              Wenn die Brille jedoch nicht geeignet ist, weil Sie versehentlich die falschen
              Größenangaben gelesen haben, sollten Sie uns innerhalb von 45 Tagen nach Erhalt der
              Brille kontaktieren, um das Problem zu lösen. Bitte senden Sie Ihre Bestellnummer,
              Produktname und eine Problembeschreibung an {supportEmail} und wir werden uns
              innerhalb von 24 Stunden um Ihr Problem kümmern.
            </p>
            <p className="my-0 mx-auto leading-[24px] mb-[40px]">
              <strong className="font-bb">· Falsche Brille erhalten/fehlende Brille:</strong> Wenn
              Sie eine falsche Brille erhalten, die nicht der von Ihnen bestellten entspricht,
              senden Sie bitte Ihre Bestellnummer, ein Foto der erhaltenen Brille, ein Foto des
              Pakets und eine Problembeschreibung an {supportEmail}. Nach der Überprüfung senden wir
              Ihnen kostenlos eine neue Brille zu und Sie können die erhaltene falsche Brille
              behalten.
            </p>
            <p className="my-0 mx-auto leading-[24px] mb-[40px]">
              <strong className="font-bb">· Nicht verfügbarer Gutschein:</strong> Aufgrund der
              vielen Arten von Gutscheinen auf der Website sind die Bedingungen für die Anwendung
              unterschiedlich. Sie haben vergessen, den Gutschein vor oder nach Ihrer Bestellung
              einzulösen, oder der Gutschein ist nicht verfügbar. Geben Sie bitte den Namen des
              Gutscheins an, den Sie nicht einlösen können (z.B. 5 € Rabatt über 50, zweite Rahmen
              50% Rabatt), und senden Sie ihn an {supportEmail}. Wir werden uns innerhalb von 24
              Stunden um Ihr Problem kümmern.
            </p>
            <p className="my-0 mx-auto leading-[24px] mb-[40px]">
              <strong className="font-bb">· Zollgebühren:</strong> Wenn Sie vom Zoll darauf
              hingewiesen werden, dass Sie Zollgebühren zahlen müssen, tun Sie dies bitte. Bitte
              senden Sie eine Kopie Ihrer Rechnung per E-Mail an: {supportEmail} und wir werden
              Ihnen den Betrag erstatten. (Hinweis: Wir übernehmen die Kosten für Zollgebühren bis
              zu 150 €, alle darüber hinausgehenden Kosten tragen Sie bitte selbst.)
            </p>
            <p className="my-0 mx-auto leading-[24px] mb-[40px]">
              <strong className="font-bb">· Lieferadresse:</strong> Bitte achten Sie bei der Eingabe
              Ihrer Adresse auf folgende Angaben: ① vollständiger Name ② Straße ( besonders die
              Hausnummer) ③ Postleitzahl ④ Stadt und Bundesland ⑤ Land. Um Zustellungsfehler zu
              vermeiden, überprüfen Sie bitte noch einmal, nachdem Sie Ihre Adresse eingegeben
              haben. Wenn Sie Probleme beim Ausfüllen Ihrer Adresse haben, wenden Sie sich bitte an
              unseren Kundendienst.
            </p>
            <p className="my-0 mx-auto leading-[24px] mb-[40px]">
              <strong className="font-bb">· Rezept ausfüllen:</strong> Wenn Sie nicht wissen, wie
              Sie Ihr Rezept bei der Bestellung ausfüllen sollen. Bitte geben Sie Ihrem
              Rezept/Brillenpass an und senden Sie ihn an {supportEmail}. Unsere Optiker werden
              Ihnen innerhalb von 24 Stunden helfe
            </p>
            <p className="my-0 mx-auto leading-[24px] mb-[40px]">
              <strong className="font-bb">· Fehlgeschlagene Logistik:</strong>Standard-Express 10-22
              Tage. Business-Express 6-11 Tage. Normalerweise erhalten Sie Ihre Bestellung innerhalb
              von zwei Wochen nach der Bestellung. Wenn Sie feststellen, dass Ihr Paket eine
              logistische Abweichung aufweist, geben Sie bitte Ihre Bestellnummer und eine
              Problembeschreibung an {supportEmail}. Wir werden uns innerhalb von 24 Stunden um Ihr
              Problem kümmern.
            </p>
            <p className="my-0 mx-auto leading-[24px] mb-[40px]">
              <strong className="font-bb">· Die verlorene Brille:</strong> In folgenden Fällen
              stellen wir die ursprüngliche Bestellung bedingungslos erneut aus: Der Kunde hat einen
              eindeutigen Verlustnachweis erbracht; Die Post zeigte eine ordnungsgemäße Zustellung,
              und der Kunde kontaktierte die örtliche Post mehrmals ohne Ergebnis. Es gab Lieferzeit
              und Frachtbriefnummer, aber keine logistischen Informationen.
            </p>
            <p className="my-0 mx-auto leading-[24px] mb-[40px]">
              <strong className="font-bb">· Transportschäden:</strong> Wenn die Brille durch den
              Transport beschädigt wird, ersetzen wir die Brille kostenlos oder geben Ihnen eine
              teilweise Rückerstattung. Bitte senden Sie Ihre Bestellnummer, ein Bild der erhaltenen
              Brille, ein Bild des Pakets und eine Problembeschreibung an {supportEmail}. Wir werden
              uns innerhalb von 24 Stunden um Ihr Problem kümmern.
            </p>
            <p className="my-0 mx-auto leading-[24px] mb-[40px]">
              <strong className="font-bb">· Beschädigt innerhalb von 45 Tagen:</strong>Kostenlose
              Rücksendung ist innerhalb von 45 Tagen nach Ankunft der Lieferung möglich, falls es
              sich um einen nicht beabsichtigten Schaden handelt. Bitte senden Sie Ihre
              Bestellnummer, ein Foto Ihrer Brille mit der Stelle, an der der Schaden aufgetreten
              ist, und eine Beschreibung des Problems an {supportEmail}. Wir werden uns innerhalb
              von 24 Stunden um Ihr Problem kümmern. Diese Garantie erstreckt sich nicht auf die
              normale Abnutzung der Rahmen, Gläser oder BeschichtungenKostenlose Rücksendung ist
              innerhalb von 45 Tagen nach Ankunft der Lieferung möglich, falls es sich um einen
              nicht beabsichtigten Schaden handelt. Diese Garantie erstreckt sich nicht auf die
              normale Abnutzung der Rahmen, Gläser oder Beschichtungen.
            </p>
            <p className="my-0 mx-auto leading-[24px] mb-[40px]">
              <strong className="font-bb">· Beschädigt innerhalb von 3 Monaten:</strong> Wenn es
              durch nicht-menschliche Faktoren beschädigt ist und nicht innerhalb von 3 Monaten
              normal genutzt werden kann (ausgenommen normale Abnutzung), wenden Sie sich bitte an
              unser Kundendienstzentrum, um dieses Problem zu lösen. Wenn es länger als 3 Monate
              dauert, geben wir Ihnen den besten Rabatt für Ihren nächsten Einkauf.
            </p>
            {/* ! ai偷懒了，这里德语迁移要补充的 */}
            {/* Additional German content continues... */}

            <h2 className="text-center font-bb my-[15px] text-[21px]">
              Zusätzliches Rezept / Rezeptaktualisierung / Auftragsänderung / Auftragsstornierung
            </h2>

            <p className="my-0 mx-auto leading-[24px] mb-[40px]">
              Für die Brillen,die ohne Rezept sind, akzeptieren wir zusätzliches Rezept /
              Auftragsänderung / Auftragsstornierung, bevor wir Ihre Bestellung versenden. In Bezug
              auf die Anforderung der Rezeptaktualisierung müssen Sie uns vor der Verarbeitung der
              Brillengläsern benachrichtigen. Bei Preisunterschieden wird ein Aufpreis erhoben.
              Bitte kontaktieren Sie uns so bald wie möglich, damit wir Ihre Bestellung entsprechend
              und rechtzeitig bearbeiten können. <br />
              Aufgrund der schnellen Bearbeitung und Lieferung，Wenn Sie Ihre Bestellung ändern oder
              stornieren möchten, wenden Sie sich bitte innerhalb von 12 Stunden an unser
              Kundendienstteam,um zusätzliche Kosten zu vermeiden. Andernfalls lesen Sie bitte die
              folgende Tabelle, um die Details zu überprüfen. Da alle Brillengläser durch das
              gegebene Rezept angepasst werden, ist für Brillen keine kostenlose Stornierung /
              Änderung vorgesehen. Versandkosten und Differenzen sind nicht enthalten, falls
              vorhanden. In der oben genannten Situationen berechnen die Gebühren wie folgend.
              (Achtung: Erstattungen für Rückgaben aus persönlichen Gründen werden in der zweiten
              Spalte berechnet.)
            </p>

            <table className="my-[20px] mx-auto border-collapse border-spacing-0 w-[700px] border border-[#ddd]">
              <tbody>
                <tr className="bg-[#eaedf6]">
                  <td className="bg-[#d6dae5] border border-[#ddd] text-center h-[60px] align-middle break-words" />
                  <td className="border border-[#ddd] text-center h-[60px] align-middle break-words">
                    Vor dem Versand
                  </td>
                  <td className="border border-[#ddd] text-center h-[60px] align-middle break-words">
                    Nach dem Versand
                  </td>
                </tr>
                <tr>
                  <td className="bg-[#eaedf6] border border-[#ddd] text-center h-[60px] align-middle break-words">
                    Nur Rahmen
                  </td>
                  <td className="border border-[#ddd] text-center h-[60px] align-middle break-words">
                    Kostenlos
                  </td>
                  <td className="border border-[#ddd] text-center h-[60px] align-middle break-words">
                    50% des Rahmenpreises
                  </td>
                </tr>
                <tr>
                  <td className="bg-[#eaedf6] border border-[#ddd] text-center h-[60px] align-middle break-words">
                    Korrekturgläser
                  </td>
                  <td className="border border-[#ddd] text-center h-[60px] align-middle break-words">
                    10% des Bestellbetrags
                  </td>
                  <td className="border border-[#ddd] text-center h-[60px] align-middle break-words">
                    50% des Rahmenpreises + 50% des Gläserpreises
                  </td>
                </tr>
              </tbody>
            </table>

            <p className="my-0 mx-auto leading-[24px] mb-[40px]">
              <strong className="font-bb">Hinweis: </strong>Hier können Sie Ihren Bestellstatus
              verfolgen -
              <span className="text-[#0000ee]">
                <Link href="/track-order" className="text-[#0000ee]">
                  {' '}
                  Bestellung verfolgen
                </Link>
              </span>
            </p>

            <div className="flex">
              <div className="left">
                <Image
                  src="/static-page/return-refund/return-refund-02.jpeg"
                  alt="How to return"
                  width={276}
                  height={200}
                />
              </div>
              <div className="flex flex-col justify-center w-[calc(100%-276px)] bg-[#f4f6f8] p-[20px_30px] box-border">
                <h2 className="text-center font-bb my-[15px] mt-0 text-[21px]">
                  So geben Sie Ihre Brille zurück
                </h2>
                <p className="m-0 leading-[24px]">
                  <strong> ·</strong> Kontaktieren Sie uns per E-Mail unter {supportEmail} innerhalb
                  von 45 Tagen nach Erhalt Ihrer Brille. Alle Rücksendungen müssen in ihrem
                  ungetragenen, ursprünglichen Zustand zurückgesandt werden.
                </p>
                <p className="m-0 leading-[24px]">
                  <strong className="font-bb"> ·</strong> Verpacken Sie Ihre Brille sicher und
                  hinterlassen Sie eine Notiz mit Ihrem Namen, Ihrer Bestellnummer und einer kurzen
                  Beschreibung des Rückgabegrundes; oder eine Kopie des Rezeptes von Ihrem Arzt
                  erhalten haben, damit Zeelool die Brille untersuchen kann.
                </p>
                <p className="m-0 leading-[24px]">
                  <strong> ·</strong> Zeelool würde es bedauern, falls Ihre Brille während des
                  Versands verloren gehen würde. Daher wird empfohlen, Ihre Rücksendungen nach einer
                  nachvollziehbaren Methode zu versenden. Bitte senden Sie uns die
                  Verfolgungsnummer, wenn Sie die Brille an uns senden.
                </p>
                <p className="m-0 leading-[24px]">
                  <strong> ·</strong> Sobald Zeelool die zurückgegebenen Artikel erhalten hat,
                  werden Sie innerhalb von 3 Werktagen zurückerstattet.
                </p>
                <p className="m-0 leading-[24px]">
                  <strong className="font-bb">· Anmerkungen:</strong> Wir übernehmen das Rückporto
                  nicht (außer unserer Verantwortung) und Sie müssen es selbst tragen.
                </p>
                <p className="m-0 leading-[24px]">
                  <strong> .</strong> Versandkosten können in folgenden Situationen erstattet
                  werden: Versandverzögerung, falsche Stile.
                </p>
                <p className="m-0 leading-[24px]">
                  <strong> .</strong>Versandkosten konnten in den folgenden Situationen nicht
                  erstattet werden: Abneigung, Größenproblem, falsches Rezept / falsche Adresse.
                </p>
              </div>
            </div>
          </div>
        </div>
      </WebOnly>

      <WapOnly>
        <div className="px-[16px]">
          <div className="p-0">
            <p
              className="text-center my-[25px] leading-[24px] text-[12px]"
              style={{
                fontFamily: 'BricolageGrotesque-Regular',
              }}
            >
              Zeelool hat sich zum Ziel gesetzt, Ihnen eine perfekte Brille zum besten Preis
              anzubieten. Wenn Sie Probleme haben, zögern Sie bitte nicht, uns zu kontaktieren.
              <br />
              Unser Kundendienst wird Ihnen innerhalb von 45 Tagen nach Erhalt der Brille eine
              vernünftige Lösung für alle Arten von Problemen mit der Brille anbieten.
            </p>

            <div className="space-y-[40px]">
              <p
                className="my-0 mx-auto mb-[40px] leading-[24px] text-[12px]"
                style={{
                  fontFamily: 'BricolageGrotesque-Regular',
                }}
              >
                <strong> · Adresse der Rücksendung: </strong>Wenn Sie den Artikel zurückschicken
                möchten, bitte senden Sie Ihre Bestellnummer und den Grund für Rücksendung an. Unser
                Kundendienst wird Ihnen weiter die Rücksendeadresse mitteilen. Achtung: Die auf dem
                Paket angegebene Adresse ist nicht korrekte Rücksendeadresse. Rückerstattungen
                können nicht bearbeitet werden, wenn Sie an falsche Adresse schicken. Wir bitten um
                Verständnis.
              </p>
              <p
                className="my-0 mx-auto mb-[40px] leading-[24px] text-[12px]"
                style={{
                  fontFamily: 'BricolageGrotesque-Regular',
                }}
              >
                <strong> · Farbunterschied: </strong>Aufgrund unterschiedlicher Lichtverhältnisse in
                Sonnenlicht und Bildschirm können einige visuelle Unterschiede auftreten. Waren sind
                in Naturalien vorzuziehen. Bitte senden Sie Ihre Bestellnummer, ein Foto der
                erhaltenen Brille und eine Problembeschreibung an . Wir werden uns innerhalb von 24
                Stunden um Ihr Problem kümmern. Wenn Sie der Meinung sind, dass die Brille nicht
                Ihren Erwartungen entspricht, wenden Sie sich bitte innerhalb von 45 Tagen nach
                Erhalt der Brille an unseren Kundendienst.
              </p>
              <p
                className="my-0 mx-auto mb-[40px] leading-[24px] text-[12px]"
                style={{
                  fontFamily: 'BricolageGrotesque-Regular',
                }}
              >
                <strong> · Über Rezept: </strong>Aufgrund unterschiedlicher Lichtverhältnisse in
                Sonnenlicht und Bildschirm können einige visuelle Unterschiede auftreten. Waren sind
                in Naturalien vorzuziehen. Bitte senden Sie Ihre Bestellnummer, ein Foto der
                erhaltenen Brille und eine Problembeschreibung an . Wir werden uns innerhalb von 24
                Stunden um Ihr Problem kümmern. Wenn Sie der Meinung sind, dass die Brille nicht
                Ihren Erwartungen entspricht, wenden Sie sich bitte innerhalb von 45 Tagen nach
                Erhalt der Brille an unseren Kundendienst.
              </p>
              <p
                className="my-0 mx-auto mb-[40px] leading-[24px] text-[12px]"
                style={{
                  fontFamily: 'BricolageGrotesque-Regular',
                }}
              >
                <strong> · Zusätzliches Rezept: </strong> Innerhalb von 12 Stunden nach der
                Bestellung, können Sie sich an den Kundendienst wenden, um das Brillenrezept ändern.
                Danach können Sie es nicht mehr ändern. Bitte senden Sie Ihre Bestellnummer, ein
                Bild Ihres Rezeptes und eine Problembeschreibung an . Wir werden Ihnen innerhalb von
                24 Stunden bei der Änderung helfen. Wenn Sie nach Erhalt des Rahmens eine
                Korrekturbrille wünschen, brauchen Sie nur für die Gläser zu bezahlen, um eine ganze
                Brille zu erhalten.
              </p>
              <p
                className="my-0 mx-auto mb-[40px] leading-[24px] text-[12px]"
                style={{
                  fontFamily: 'BricolageGrotesque-Regular',
                }}
              >
                <strong> · Über die Größe:</strong> Aufgrund unterschiedlicher Messtechniken und
                Winkel tritt eine Abweichung der Rahmenparameter von ca. 1-2 mm auf, wobei die
                tatsächlichen Parameter in natura vorherrschen. Sie können die passende Brille
                finden, indem Sie sich die Größentabelle auf jeder Brillendetailseite ansehen. Wenn
                die Brille jedoch nicht geeignet ist, weil Sie versehentlich die falschen
                Größenangaben gelesen haben, sollten Sie uns innerhalb von 45 Tagen nach Erhalt der
                Brille kontaktieren, um das Problem zu lösen. Bitte senden Sie Ihre Bestellnummer,
                Produktname und eine Problembeschreibung an und wir werden uns innerhalb von 24
                Stunden um Ihr Problem kümmern.
              </p>{' '}
              <p
                className="my-0 mx-auto mb-[40px] leading-[24px] text-[12px]"
                style={{
                  fontFamily: 'BricolageGrotesque-Regular',
                }}
              >
                <strong> · Falsche Brille erhalten/fehlende Brille:</strong> Wenn Sie eine falsche
                Brille erhalten, die nicht der von Ihnen bestellten entspricht, senden Sie bitte
                Ihre Bestellnummer, ein Foto der erhaltenen Brille, ein Foto des Pakets und eine
                Problembeschreibung an . Nach der Überprüfung senden wir Ihnen kostenlos eine neue
                Brille zu und Sie können die erhaltene falsche Brille behalten.
              </p>
              <p
                className="my-0 mx-auto mb-[40px] leading-[24px] text-[12px]"
                style={{
                  fontFamily: 'BricolageGrotesque-Regular',
                }}
              >
                <strong> · Nicht verfügbarer Gutschein:</strong> Aufgrund der vielen Arten von
                Gutscheinen auf der Website sind die Bedingungen für die Anwendung unterschiedlich.
                Sie haben vergessen, den Gutschein vor oder nach Ihrer Bestellung einzulösen, oder
                der Gutschein ist nicht verfügbar. Geben Sie bitte den Namen des Gutscheins an, den
                Sie nicht einlösen können (z.B. 5 € Rabatt über 50, zweite Rahmen 50% Rabatt), und
                senden Sie ihn an . Wir werden uns innerhalb von 24 Stunden um Ihr Problem kümmern.
              </p>
              <p
                className="my-0 mx-auto mb-[40px] leading-[24px] text-[12px]"
                style={{
                  fontFamily: 'BricolageGrotesque-Regular',
                }}
              >
                <strong> · Zollgebühren:</strong> Wenn Sie vom Zoll darauf hingewiesen werden, dass
                Sie Zollgebühren zahlen müssen, tun Sie dies bitte. Bitte senden Sie eine Kopie
                Ihrer Rechnung per E-Mail an: und wir werden Ihnen den Betrag erstatten. (Hinweis:
                Wir übernehmen die Kosten für Zollgebühren bis zu 150 €, alle darüber hinausgehenden
                Kosten tragen Sie bitte selbst.)
              </p>
              <p
                className="my-0 mx-auto mb-[40px] leading-[24px] text-[12px]"
                style={{
                  fontFamily: 'BricolageGrotesque-Regular',
                }}
              >
                <strong> · Lieferadresse:</strong> Bitte achten Sie bei der Eingabe Ihrer Adresse
                auf folgende Angaben: ① vollständiger Name ② Straße ( besonders die Hausnummer) ③
                Postleitzahl ④ Stadt und Bundesland ⑤ Land. Um Zustellungsfehler zu vermeiden,
                überprüfen Sie bitte noch einmal, nachdem Sie Ihre Adresse eingegeben haben. Wenn
                Sie Probleme beim Ausfüllen Ihrer Adresse haben, wenden Sie sich bitte an unseren
                Kundendienst.
              </p>
              <p
                className="my-0 mx-auto mb-[40px] leading-[24px] text-[12px]"
                style={{
                  fontFamily: 'BricolageGrotesque-Regular',
                }}
              >
                <strong> ·Rezept ausfüllen:</strong> Wenn Sie nicht wissen, wie Sie Ihr Rezept bei
                der Bestellung ausfüllen sollen. Bitte geben Sie Ihrem Rezept/Brillenpass an und
                senden Sie ihn an . Unsere Optiker werden Ihnen innerhalb von 24 Stunden helfe
              </p>
              <p
                className="my-0 mx-auto mb-[40px] leading-[24px] text-[12px]"
                style={{
                  fontFamily: 'BricolageGrotesque-Regular',
                }}
              >
                <strong> · Fehlgeschlagene Logistik:</strong> Standard-Express 10-22 Tage.
                Business-Express 6-11 Tage. Normalerweise erhalten Sie Ihre Bestellung innerhalb von
                zwei Wochen nach der Bestellung. Wenn Sie feststellen, dass Ihr Paket eine
                logistische Abweichung aufweist, geben Sie bitte Ihre Bestellnummer und eine
                Problembeschreibung an . Wir werden uns innerhalb von 24 Stunden um Ihr Problem
                kümmern.
              </p>
              <p
                className="my-0 mx-auto mb-[40px] leading-[24px] text-[12px]"
                style={{
                  fontFamily: 'BricolageGrotesque-Regular',
                }}
              >
                <strong> · Die verlorene Brille: </strong> In folgenden Fällen stellen wir die
                ursprüngliche Bestellung bedingungslos erneut aus: Der Kunde hat einen eindeutigen
                Verlustnachweis erbracht; Die Post zeigte eine ordnungsgemäße Zustellung, und der
                Kunde kontaktierte die örtliche Post mehrmals ohne Ergebnis. Es gab Lieferzeit und
                Frachtbriefnummer, aber keine logistischen Informationen.
              </p>
              <p
                className="my-0 mx-auto mb-[40px] leading-[24px] text-[12px]"
                style={{
                  fontFamily: 'BricolageGrotesque-Regular',
                }}
              >
                <strong> · Transportschäden:</strong> Wenn die Brille durch den Transport beschädigt
                wird, ersetzen wir die Brille kostenlos oder geben Ihnen eine teilweise
                Rückerstattung. Bitte senden Sie Ihre Bestellnummer, ein Bild der erhaltenen Brille,
                ein Bild des Pakets und eine Problembeschreibung an . Wir werden uns innerhalb von
                24 Stunden um Ihr Problem kümmern.
              </p>
              <p
                className="my-0 mx-auto mb-[40px] leading-[24px] text-[12px]"
                style={{
                  fontFamily: 'BricolageGrotesque-Regular',
                }}
              >
                <strong> · Beschädigt innerhalb von 45 Tagen: </strong> Kostenlose Rücksendung ist
                innerhalb von 45 Tagen nach Ankunft der Lieferung möglich, falls es sich um einen
                nicht beabsichtigten Schaden handelt. Bitte senden Sie Ihre Bestellnummer, ein Foto
                Ihrer Brille mit der Stelle, an der der Schaden aufgetreten ist, und eine
                Beschreibung des Problems an . Wir werden uns innerhalb von 24 Stunden um Ihr
                Problem kümmern. Diese Garantie erstreckt sich nicht auf die normale Abnutzung der
                Rahmen, Gläser oder BeschichtungenKostenlose Rücksendung ist innerhalb von 45 Tagen
                nach Ankunft der Lieferung möglich, falls es sich um einen nicht beabsichtigten
                Schaden handelt. Diese Garantie erstreckt sich nicht auf die normale Abnutzung der
                Rahmen, Gläser oder Beschichtungen.
              </p>
              <p
                className="my-0 mx-auto mb-[40px] leading-[24px] text-[12px]"
                style={{
                  fontFamily: 'BricolageGrotesque-Regular',
                }}
              >
                <strong> · Beschädigt innerhalb von 3 Monaten:</strong>
                {''} Wenn es durch nicht-menschliche Faktoren beschädigt ist und nicht innerhalb von
                3 Monaten normal genutzt werden kann (ausgenommen normale Abnutzung), wenden Sie
                sich bitte an unser Kundendienstzentrum, um dieses Problem zu lösen. Wenn es länger
                als 3 Monate dauert, geben wir Ihnen den besten Rabatt für Ihren nächsten Einkauf.
              </p>
              <h2 className="text-center font-bb my-[15px] text-[18px]">
                Zusätzliches Rezept / Rezeptaktualisierung / Auftragsänderung / Auftragsstornierung
              </h2>
              <p
                className="my-0 text-[12px] leading-[24px]"
                style={{
                  fontFamily: 'BricolageGrotesque-Regular',
                }}
              >
                Für die Brillen,die ohne Rezept sind, akzeptieren wir zusätzliches Rezept /
                Auftragsänderung / Auftragsstornierung, bevor wir Ihre Bestellung versenden. In
                Bezug auf die Anforderung der Rezeptaktualisierung müssen Sie uns vor der
                Verarbeitung der Brillengläsern benachrichtigen. Bei Preisunterschieden wird ein
                Aufpreis erhoben. Bitte kontaktieren Sie uns so bald wie möglich, damit wir Ihre
                Bestellung entsprechend und rechtzeitig bearbeiten können.
              </p>
              <p
                className="my-0 text-[12px] mb-[40px] leading-[24px]"
                style={{
                  fontFamily: 'BricolageGrotesque-Regular',
                }}
              >
                Aufgrund der schnellen Bearbeitung und Lieferung，Wenn Sie Ihre Bestellung ändern
                oder stornieren möchten, wenden Sie sich bitte innerhalb von 12 Stunden an unser
                Kundendienstteam,um zusätzliche Kosten zu vermeiden. Andernfalls lesen Sie bitte die
                folgende Tabelle, um die Details zu überprüfen. Da alle Brillengläser durch das
                gegebene Rezept angepasst werden, ist für Brillen keine kostenlose Stornierung /
                Änderung vorgesehen. Versandkosten und Differenzen sind nicht enthalten, falls
                vorhanden. In der oben genannten Situationen berechnen die Gebühren wie folgend.
                (Achtung: Erstattungen für Rückgaben aus persönlichen Gründen werden in der zweiten
                Spalte berechnet.)
              </p>
              {/* Mobile German content continues with similar structure but mobile-optimized styles... */}
              <table className="my-[20px] mx-auto border-collapse border-spacing-0 w-full text-[12px] border border-[#ddd]">
                <tbody>
                  <tr className="bg-[#eaedf6]">
                    <td className="bg-[#d6dae5] border border-[#ddd] text-center h-[60px] align-middle break-words w-[33.33%] text-[12px]" />
                    <td className="border border-[#ddd] text-center h-[60px] align-middle break-words w-[33.33%] text-[12px]">
                      Vor dem Versand
                    </td>
                    <td className="border border-[#ddd] text-center h-[60px] align-middle break-words w-[33.33%] text-[12px]">
                      Nach dem Versand
                    </td>
                  </tr>
                  <tr>
                    <td className="bg-[#eaedf6] border border-[#ddd] text-center h-[60px] align-middle break-words w-[33.33%] text-[12px]">
                      Nur Rahmen
                    </td>
                    <td className="border border-[#ddd] text-center h-[60px] align-middle break-words w-[33.33%] text-[12px]">
                      Kostenlos
                    </td>
                    <td className="border border-[#ddd] text-center h-[60px] align-middle break-words w-[33.33%] text-[12px]">
                      50% des Rahmenpreises
                    </td>
                  </tr>
                  <tr>
                    <td className="bg-[#eaedf6] border border-[#ddd] text-center h-[60px] align-middle break-words w-[33.33%] text-[12px]">
                      Korrekturgläser
                    </td>
                    <td className="border border-[#ddd] text-center h-[60px] align-middle break-words w-[33.33%] text-[12px]">
                      10% des Bestellbetrags
                    </td>
                    <td className="border border-[#ddd] text-center h-[60px] align-middle break-words w-[33.33%] text-[12px]">
                      50% des Rahmenpreises + 50% des Gläserpreises
                    </td>
                  </tr>
                </tbody>
              </table>
              <p
                className="my-0 mx-auto mb-[40px] leading-[24px] text-[12px]"
                style={{ fontFamily: 'BricolageGrotesque-Regular' }}
              >
                <strong> Hinweis:</strong> Hier können Sie Ihren Bestellstatus verfolgen -
                <Link href="/track-order" className="text-[#0000ee]">
                  {' '}
                  Bestellung verfolgen
                </Link>
              </p>
              <div className="flex flex-col w-full bg-[#f4f6f8] p-[20px_30px] box-border mb-[50px]">
                <h2 className="text-center font-bb my-[15px] mt-0">
                  So geben Sie Ihre Brille zurück
                </h2>
                <p
                  className="m-0 leading-[24px] text-[12px]"
                  style={{ fontFamily: 'BricolageGrotesque-Regular' }}
                >
                  <strong> ·</strong> Kontaktieren Sie uns per E-Mail unter innerhalb von 45 Tagen
                  nach Erhalt Ihrer Brille. Alle Rücksendungen müssen in ihrem ungetragenen,
                  ursprünglichen Zustand zurückgesandt werden.
                </p>
                <p className="m-0 leading-[24px] text-[12px] font-bb">
                  <strong> ·</strong> Verpacken Sie Ihre Brille sicher und hinterlassen Sie eine
                  Notiz mit Ihrem Namen, Ihrer Bestellnummer und einer kurzen Beschreibung des
                  Rückgabegrundes; oder eine Kopie des Rezeptes von Ihrem Arzt erhalten haben, damit
                  Zeelool die Brille untersuchen kann.
                </p>
                <p
                  className="m-0 leading-[24px] text-[12px]"
                  style={{ fontFamily: 'BricolageGrotesque-Regular' }}
                >
                  <strong> ·</strong> Zeelool würde es bedauern, falls Ihre Brille während des
                  Versands verloren gehen würde. Daher wird empfohlen, Ihre Rücksendungen nach einer
                  nachvollziehbaren Methode zu versenden. Bitte senden Sie uns die
                  Verfolgungsnummer, wenn Sie die Brille an uns senden.
                </p>
                <p
                  className="m-0 leading-[24px] text-[12px]"
                  style={{ fontFamily: 'BricolageGrotesque-Regular' }}
                >
                  <strong> · </strong> Sobald Zeelool die zurückgegebenen Artikel erhalten hat,
                  werden Sie innerhalb von 3 Werktagen zurückerstattet.
                </p>
                <p className="m-0 leading-[24px] text-[12px]  font-bb">
                  <strong> · Anmerkungen:</strong> Wir übernehmen das Rückporto nicht (außer unserer
                  Verantwortung) und Sie müssen es selbst tragen.
                </p>
                <p
                  className="m-0 leading-[24px] text-[12px]"
                  style={{ fontFamily: 'BricolageGrotesque-Regular' }}
                >
                  <strong> ·</strong> Versandkosten können in folgenden Situationen erstattet
                  werden: Versandverzögerung, falsche Stile.
                </p>
                <p
                  className="m-0 leading-[24px] text-[12px]"
                  style={{ fontFamily: 'BricolageGrotesque-Regular' }}
                >
                  <strong> ·</strong> Versandkosten konnten in den folgenden Situationen nicht
                  erstattet werden: Abneigung, Größenproblem, falsches Rezept / falsche Adresse.
                </p>
                {/* More mobile content... */}
              </div>
            </div>
          </div>
        </div>
      </WapOnly>
    </>
  );
}
